export default __webpack_public_path__ + "static/media/logo-us-nordstorm.ef1ebe44.svg";